import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DashboardSection } from '../models/DashboardSection';

@Injectable({
	providedIn: 'root',
})
export class StorageService {
	private readonly dashboardSectionSubject: BehaviorSubject<DashboardSection[]>;
	public currentSection: Observable<DashboardSection[]>;

	constructor() {
		const dashboardSection = localStorage.getItem('__dashboardSection');
		const initialSections = this.safeParse<DashboardSection[]>(dashboardSection, []);
		this.dashboardSectionSubject = new BehaviorSubject<DashboardSection[]>(initialSections);
		this.currentSection = this.dashboardSectionSubject.asObservable();
	}

	public get dashboardSectionValue(): DashboardSection[] {
		return this.dashboardSectionSubject.value;
	}

	public updateSection(sections: DashboardSection[]) {
		localStorage.setItem('__dashboardSection', JSON.stringify(sections));
		this.dashboardSectionSubject.next(sections);
	}

	private safeParse<T>(value: string | null, fallback: T): T {
		if (!value) {
			return fallback;
		}
		try {
			return JSON.parse(value) as T;
		} catch (e) {
			return fallback;
		}
	}
}
